import { Col, Row } from "react-bootstrap";
import { compose, withState } from "recompose";

import BudgetCategoryItemForm from "./BudgetCategoryItemForm";
import BudgetItemForm from "./BudgetItemForm";
import Button from "../../elements/CustomButton/CustomButton";
import { FormattedMessage } from "react-intl";
import NotificationProvider from "../../elements/NotificationContent/Notifications";
import Queries from "../../queries/queries2";
import React from "react";
import SideModal from "../../elements/Modal/SideModal";
import _ from "lodash";
import { graphql } from "react-apollo";
import moment from "moment";

class CreateBudgetItemSideModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      initialValues: {
        company: { id: props.companyId },
        projectId: "",
        tiersId: props.tiersId,
        categoryId: props.categoryId,
        // isChiffreDAffaires: props.isChiffreDAffaires,
        year: (moment().month() > 5) ? moment().year() : moment().year() - 1,
        // month: moment().month() + 1,
        repCount: 1,
        isReal: props.isReal,
        showAlertPreviousNext: false
      }
    };
  }

  deleteBudgetItems = async values => {
    const variables = {
      companyId: values.company.id,
      projectId: values.projectId || "",
      tiersId: values.tiersId,
      // categoryId: values.categoryId || "",
      year: values.year
    };
    this.props.setWorkInProgress(true);
    console.log("variables", variables);
    try {
      const res = await this.props
        .deleteBudgetItems({
          variables
        })
        .then(r => {
          console.log("r", r);
          this.props.close();
          this.props.setWorkInProgress(false);
        });

      console.log("res", res);
      this.sendSuccessUpdateNotification();
      this.props.setWorkInProgress(false);
    } catch (e) {
      console.log(e);
      this.sendFailureUpdateNotification();
      this.props.setWorkInProgress(false);
    }
  };

  deleteBudgetCategoryItems = async values => {
    const variables = {
      companyId: values.company.id,
      projectId: values.projectId || "",
      tiersId: values.tiersId || "",
      tiersClientId: values.tiersClientId || "",
      categoryId: values.categoryId || "",
      year: values.year
      // categoryId: values.categoryId,
    };
    this.props.setWorkInProgress(true);
    console.log("variables", variables);
    try {
      const res = await this.props
        .deleteBudgetCategoryItems({
          variables
        })
        .then(r => {
          console.log("r", r);
          this.props.close();
          this.props.setWorkInProgress(false);
        });

      console.log("res", res);
      this.sendSuccessUpdateNotification();
      this.props.setWorkInProgress(false);
    } catch (e) {
      console.log(e);
      this.sendFailureUpdateNotification();
      this.props.setWorkInProgress(false);
    }
  };

  saveItems = async values => {
    console.log("saveItems ", values);
    this.props.setWorkInProgress(true);
    const items = _.map(values.items, c =>
      _.omit(c, ["monthText", "realValue", "dateSaisie", "tiersCollaborator"])
    );

    const variables = {
      companyId: values.company.id,
      projectId: values.projectId || "",
      tiersId: values.tiersId || "",
      tiersClientId: values.tiersClientId || "",
      categoryId: values.categoryId || "",
      isReal: values.isReal,
      items
    };

    console.log("createBudgetItems", variables);
    try {
      const res = await this.props
        .createBudgetItems({
          variables,
          refetchQueries: [
            {
              query: Queries.getClientsForBudget,
              variables: { companyId: values.company.id, tiersId: "" }
            }
          ]
        })
        .then(r => {
          console.log("r", r);

          if (!!!this.props.goPreviousBudget && !!!this.props.goNextBudget) {
            this.props.close();
          }
        });

      console.log("res", res);
      this.props.setWorkInProgress(false);

      this.sendSuccessUpdateNotification();
    } catch (e) {
      this.props.setWorkInProgress(false);
      console.log(e);
      this.sendFailureUpdateNotification();
    }
  };

  saveCategoryItems = async values => {
    console.log("saveCategoryItems ", values);
    this.props.setWorkInProgress(true);
    const items = _.map(values.items, c =>
      _.omit(c, ["monthText", "realValue", "dateSaisie", "tiersCollaborator"])
    );

    const variables = {
      companyId: values.company.id,
      projectId: values.projectId || "",
      tiersId: values.tiersId || "",
      tiersClientId: values.tiersClientId || "",
      categoryId: values.categoryId || "",
      isReal: values.isReal,
      // categoryId: values.categoryId,
      items
    };

    console.log("createBudgetCategoryItems", variables);
    try {
      const res = await this.props
        .createBudgetCategoryItems({
          variables,
          refetchQueries: [
            {
              query: Queries.getCategoriesForBudget,
              variables: { companyId: values.company.id, categoryId: "" }
            }
          ]
        })
        .then(r => {
          console.log("r", r);

          // this.props.close();
        });

      console.log("res", res);
      this.props.setWorkInProgress(false);

      this.sendSuccessUpdateNotification();
    } catch (e) {
      console.log(e);
      this.props.setWorkInProgress(false);

      this.sendFailureUpdateNotification();
    }
  };

  sendSuccessUpdateNotification() {
    let notif = NotificationProvider.getSuccessNotification();
    notif.message = <FormattedMessage id="ids_budgetHasBeenUpdated" />;
    if (this.props.sendNotification) this.props.sendNotification(notif);
  }

  sendFailureUpdateNotification() {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = (
      <FormattedMessage id="ids_budgetUpdateFailed_notification" />
    );
    if (this.props.sendNotification) this.props.sendNotification(notif);
  }

  sendAlertUpdateNotification() {
    let notif = NotificationProvider.getFailureNotification();
    notif.message = (
      <div>
        <FormattedMessage id="ids_budgetHasNotBeenSaved" />
        {" "}
        {this.props.categoryName}
      </div>
    );

    if (this.props.sendNotification) this.props.sendNotification(notif);
  }

  close = () => {
    console.log("close.state", this.state);
    // this.setState({ dirty: false });
    this.props.close();
  };

  goPreviousBudget = sendSuccessUpdateNotification => {
    console.log("goPreviousBudget.props", this.props);
    if (this.state.showAlertPreviousNext === true) {
      this.sendAlertUpdateNotification();
    }
    if (this.props && this.props.cloneFrom && this.props.goPreviousBudget) {
      const variables = {
        selectedId: this.props.cloneFrom.selectedId
      };
      this.props.goPreviousBudget({ variables });
      // this.sendSuccessUpdateNotification();
    }
  };

  goNextBudget = () => {
    console.log("goNextBudget.props", this.props);
    if (this.state.showAlertPreviousNext === true) {
      this.sendAlertUpdateNotification();
    }
    if (this.props && this.props.cloneFrom && this.props.goNextBudget) {
      const variables = {
        selectedId: this.props.cloneFrom.selectedId
      };
      this.props.goNextBudget({ variables });
      // this.sendFailureUpdateNotification();
    }
  };

  setShowAlertPreviousNext = (value) => {
    this.state.showAlertPreviousNext = value;
  }

  static getDerivedStateFromProps = async (props, state) => {
    // console.log("115 - getDerivedStateFromProps", props);
    // if (props && props.data && props.data.company) {
    //   state.accountingPlan = props.data.company.accountingPlans;
    // }
  };

  render = () => {
    const {
      title,
      sideModalVisible,
      // close, // handler to close modal
      companyId,
      currencyId,
      sendNotification,
      intl,
      // cloneFrom,
      tiersId,
      projectId,
      tiersClientId,
      previousNextCommand,
      categoryId,
      isReal,
      role
    } = this.props;

    // console.log("176 - tiersId=", tiersId);
    // console.log("177 - projectId=", projectId);
    // console.log("178 - tiersClientId=", tiersClientId);
    // console.log("179 - companyId=", companyId);
    // console.log("260 - P", this.props);
    // console.log("262 - S", this.state);

    const values = {
      ...this.state.initialValues,
      tiersId,
      projectId,
      companyId,
      previousNextCommand,
      isReal
    };

    let showSupplier = false;
    let showClient = false;

    // Default ...
    if (
      this.props.cloneFrom &&
      this.props.cloneFrom.categoryFamily && (
        this.props.cloneFrom.categoryFamily.ids === "ids_chiffreDAffaires" ||
        this.props.cloneFrom.categoryFamily.ids === "ids_autresRevenus"
      )
    ) {
      showClient = true;
    }
    else {
      showSupplier = true;
    }

    if (
      this.props.cloneFrom && (
        this.props.cloneFrom.ids === "ids_differenceDeReglementNegatives" ||
        this.props.cloneFrom.ids === "ids_differenceDeReglementPositives" ||
        this.props.cloneFrom.ids === "ids_perteDeChange" ||
        this.props.cloneFrom.ids === "ids_gainDeChange"
      )
    ) {
      showClient = true;
      showSupplier = true;
    }

    if (
      this.props.cloneFrom &&
      this.props.cloneFrom.categoriesParent && (
        this.props.cloneFrom.categoriesParent.ids === "ids_differenceDeReglementNegatives" ||
        this.props.cloneFrom.categoriesParent.ids === "ids_differenceDeReglementPositives" ||
        this.props.cloneFrom.categoriesParent.ids === "ids_perteDeChange" ||
        this.props.cloneFrom.categoriesParent.ids === "ids_gainDeChange"
      )
    ) {
      showClient = true;
      showSupplier = true;
    }

    // const isChiffreDAffaires = (this.props.cloneFrom &&
    //   this.props.cloneFrom.categoryFamily &&
    //   (
    //     (
    //       this.props.cloneFrom.categoryFamily.ids === "ids_chiffreDAffaires" ||
    //       this.props.cloneFrom.ids === "ids_differenceDeReglementNegatives" ||
    //       (this.props.cloneFrom.categoriesParent && this.props.cloneFrom.categoriesParent.ids === "ids_differenceDeReglementNegatives")
    //     ) ||
    //     (
    //       this.props.cloneFrom.categoryFamily.ids === "ids_autresRevenus" ||
    //       this.props.cloneFrom.ids === "ids_differenceDeReglementPositives" ||
    //       (this.props.cloneFrom.categoriesParent && this.props.cloneFrom.categoriesParent.ids === "ids_differenceDeReglementPositives")
    //     )       
    //   )
    //   ) ? true : false;



    const valuesForCategory = {
      ...values,
      tiersClientId,
      categoryId,
      // isChiffreDAffaires,
      showSupplier,
      showClient,
      isReal
    };
    const isCategoryBudgets = !!categoryId;

    // console.log("285 - valuesForCategory=", valuesForCategory);

    // if (!!!categoryId && !!!tiersId) return <div />;
    return (
      <SideModal
        // title={title}
        title={
          /*isCategoryBudgets &&*/ (true && (
            <div>
              <Row>
                <Col
                  xs={5}
                  style={{ overflow: "hidden", textOverflow: "ellipsis" }}
                >
                  {title}
                </Col>

                <Col xs={3}>
                  {!!this.props.goPreviousBudget && (
                    <Button
                      className="btn-fill pull-right"
                      icon
                      wd
                      fill
                      bsStyle="primary"
                      block
                      style={{ marginTop: "-10px", marginRight: "-30px" }}
                      disabled={this.props.skipPrevious}
                      onClick={() => this.goPreviousBudget()}
                    >
                      {intl.formatMessage({
                        id: "ids_budget_notnull_previous"
                      })}
                    </Button>
                  )}
                </Col>

                <Col xs={3}>
                  {!!this.props.goNextBudget && (
                    <Button
                      className="btn-fill pull-right"
                      wd
                      bsStyle="primary"
                      fill
                      block
                      icon
                      style={{ marginTop: "-10px", marginRight: "-30px" }}
                      // style={{ marginTop: "-10px"}}
                      disabled={this.props.skipNext}
                      onClick={() => this.goNextBudget()}
                    >
                      {intl.formatMessage({ id: "ids_budget_notnull_next" })}
                    </Button>
                  )}
                </Col>
              </Row>
            </div>
          )) || <div>{title}</div>
        }
        width="wide"
        visible={sideModalVisible}
        handleClose={this.close}
        children={
          <React.Fragment>
            {isCategoryBudgets ? (
              <BudgetCategoryItemForm
                // disabled={!!cloneFrom}
                sendNotification={sendNotification}
                companyId={companyId}
                values={valuesForCategory}
                // updateState={state => {
                //   console.log("update state", state);
                //   this.setState({ ...state,  });
                // }}
                goBack={this.close}
                save={this.saveCategoryItems}
                workInProgress={this.props.workInProgress}
                setPreviousNextCommand={this.props.setPreviousNextCommand}
                deleteBudgetItems={this.deleteBudgetCategoryItems}
                cancel={this.close}
                intl={intl}
                currencyId={currencyId}
                tiersId={tiersId}
                setShowAlertPreviousNext={this.setShowAlertPreviousNext}
                role={role}
              // goPreviousBudget={this.goPreviousBudget}
              // goNextBudget={this.goNextBudget}
              />
            ) : (
                <BudgetItemForm
                  // disabled={!!cloneFrom}
                  sendNotification={sendNotification}
                  companyId={companyId}
                  values={values}
                  // updateState={state => {
                  //   console.log("update state", state);
                  //   this.setState({ ...state,  });
                  // }}
                  goBack={this.close}
                  save={this.saveItems}
                  workInProgress={this.props.workInProgress}
                  setPreviousNextCommand={this.props.setPreviousNextCommand}
                  deleteBudgetItems={this.deleteBudgetItems}
                  cancel={this.close}
                  intl={intl}
                  currencyId={currencyId}
                  tiersId={tiersId}
                  setShowAlertPreviousNext={this.setShowAlertPreviousNext}
                  role={role}
                />
              )}
          </React.Fragment>
        }
      />
    );
  };
}

const workInProgress = withState("workInProgress", "setWorkInProgress", () => {
  return false;
});

export default compose(
  workInProgress,
  graphql(Queries.createBudgetItems, { name: "createBudgetItems" }),
  graphql(Queries.createBudgetCategoryItems, {
    name: "createBudgetCategoryItems"
  }),
  graphql(Queries.deleteBudgetItems, { name: "deleteBudgetItems" }),
  graphql(Queries.deleteBudgetCategoryItems, {
    name: "deleteBudgetCategoryItems"
  })
)(CreateBudgetItemSideModal);
